"use strict";

angular.module('app.myHockeyTv.profileSearch.profileListService', [])
  .factory('app.myHockeyTv.profileSearch.profileListService', [
    '$http', '$q',
    function ($http, $q) {
      let profiles;
      return profiles = {
        list: null,
        error: null,
        retrieve: function () {
          return $http.get(window.location.api('user_profiles/follow_all'))
            .then((response) => {

              let data = response.data;
              let i, len, profile, ref, results;
              if (data.feed) {
                profiles.list = {};
                ref = data.feed;
                results = [];
                for (i = 0, len = ref.length; i < len; i++) {
                  profile = ref[i];
                  results.push(profiles.list[profile.iuserid] = profile);
                }
              }
              return response;
            });
        },
        search: function (term, canceler) {
          let search;
          if (canceler) {
            canceler.resolve();
          }
          if (term) {
            canceler = $q.defer();
            search = $http.get(window.location.api('user_profiles/search?term=' + term), {
              timeout: canceler.promise
            });
            return {
              promise: search,
              deferred: canceler
            };
          }
        }
      };
    }
  ]);



// WEBPACK FOOTER //
// ./app.v2/components/myHockeyTv/profileSearch/profileListService.js